import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cidentifier(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>identifiers in c tutorial For Beginners</title>
 <meta name="description" content="identifiers in ctutorial for beginners.Identifier in c is a name given to a variable, method.CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,learn code in free,c programming tutorial for beginners,learn code in free online,c identifier,identifier,c identifiers" />
 <link rel="canonical" href="https://www.codeexampler.com/c-identifier" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">what are identifiers in c</h1>
   
    <div className="first">
        <a href="/c-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-short-cut-keys">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
    <h2 className="mt-4 mh2">Point of Identifiers in C:</h2>
    <p className="mt-4 para">1, Identifier in c is a name given to a variable method.<br/>
2, Blank space special symbol is not allowed <br/>
3, It must begin with a letters<br/>
4, You only type less  than 31 characters long <br/>
5, You don’t use any keyword in the same manner means or Uppercase and lowercase are different means <br/>
</p>



<h2 className='headings'>Uppercase and Lowercase example</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >   
          <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> my_name </span>
            {"\n"}{"\n"}    
                <span className="qwerty-10"> My_Name</span> 
                {"\n"}{"\n"} 
            </code>
          </pre>
          </div> 


<h2 className="mt-4 mh2">Rules of Identifier in c:</h2>
<h3 className="headings"> 1, Blank space special symbols are <br/></h3>


      <div style = {{background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px" }}>
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-10"> code</span>
                <span className="qwerty-3">-</span>
                <span className="qwerty-10">exampler</span>
                <span className="qwerty-3"> = </span>
                <span className="qwerty-7">false</span>            
            {"\n"}{"\n"}
              <span className="qwerty-10"> code</span>
              <span className="qwerty-3">.</span>
              <span className="qwerty-10">exampler</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-7">false</span>          
          {"\n"}{"\n"}
            <span className="qwerty-10"> code</span>
            <span className="qwerty-10">_</span>
            <span className="qwerty-10">exampler</span>
            <span className="qwerty-3"> = </span>
            <span className="qwerty-7">true</span>        
          {"\n"}{"\n"}
          <span className="qwerty-10"> codeexampler</span>
          <span className="qwerty-3"> = </span>
          <span className="qwerty-7">true</span>      
          {"\n"}{"\n"}
        <span className="qwerty-10"> code exampler</span>
        <span className="qwerty-3"> = </span>
        <span className="qwerty-7">false</span>
        {"\n"}{"\n"}
         </code>
         </pre>
         </div>


<h3 className="headings">2, It must begin with letters<br/></h3>



 <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
  <pre style={{ maxHeight :"100vh"}}>
    <code >
      {"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> -2a</span>                
          <span className="qwerty-3">;</span>
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">wrong </span>
      {"\n"}{"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> a2</span>                
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">true</span>
          <span className="qwerty-3">; </span>            
      {"\n"}{"\n"}
          <span className="qwerty-5"> int</span>
          <span className="qwerty-10"> _24a</span>                
          <span className="qwerty-11"> - </span>
          <span className="qwerty-7">false</span>                       
          {"\n"}{"\n"}
   </code>
   </pre>
   </div>



<h3 className="headings">3, You don’t use any reserved keyword means:<br/></h3>

       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-4"> if</span>
                <span className="qwerty-3">;</span>
                <span className="qwerty-11"> - </span>
                <span className="qwerty-7">false</span>             
            {"\n"}{"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-4"> IF</span>
                <span className="qwerty-3">;</span>
                <span className="qwerty-11"> - </span>
                <span className="qwerty-7">true</span>       
                {"\n"}{"\n"}            
         </code>
         </pre>
         </div> 

<h3 className="headings">4, You only type less  than 31 characters long <br/></h3>


       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"100vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-5"> int</span>
                <span className="qwerty-10"> a</span>                
                <span className="qwerty-3"> ; </span>
                <span className="qwerty-2"> &#47;&#47; this declare a variable means 'a' is a variable</span>
                  
            {"\n"}{"\n"}
              <span className="qwerty-10"> a</span>
              <span className="qwerty-3"> = </span>                
              <span className="qwerty-10">4</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-2"> &#47;&#47; this assigns 4 to (a) means assigns a variable a value</span>       
              {"\n"}{"\n"}
         </code>
         </pre>
         </div>  



<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-short-cut-keys">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cidentifier;